"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetPdpDynamicLink = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _contexts = require("../contexts");
var _net = require("../models/graphql-types/net");
var _queriesNet = require("../queries-net");
var _shoudSkipPdpLinkQuery = require("../utils/shoudSkipPdpLinkQuery");
/* istanbul ignore file @preserve */

const useGetPdpDynamicLink = ({
  currentStore
}) => {
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    headers,
    loading: loadingHeaders
  } = (0, _presentationHttp.useHeaders)();
  const {
    productCode,
    type
  } = (0, _contexts.useFeedbackBenefitDialog)();
  const {
    data,
    error
  } = (0, _fetching.useGraphqlQuery)({
    query: _queriesNet.pdpUrlQuery,
    url: graphQlNetUrl,
    headers,
    variables: {
      storeName: currentStore,
      productCode: productCode ?? ''
    },
    skip: (0, _shoudSkipPdpLinkQuery.shouldSkipPdpLinkQuery)({
      loadingHeaders,
      type,
      productCode
    }),
    swrConfig: {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false
    }
  });
  return {
    dynamicLink: data?.product?.pdpUrl?.dynamicSharingUrl,
    loading: type === _net.FeedbackBenefitBannerType.ShareAndEarn && productCode != null && productCode !== '' && !data && !error
  };
};
exports.useGetPdpDynamicLink = useGetPdpDynamicLink;
